import markFull from '../../assets/brand/placio-mark.svg';
import mark32 from '../../assets/brand/placio-mark-32.svg';
import mark16 from '../../assets/brand/placio-mark-16.svg';

/**
 * Symbole Placio (« portail en P », pixel-art). Trois dessins, chacun fait pour sa
 * taille : 16 px (favicon), 32 px (icône) et la version détaillée (pierres, battant
 * ouvert). Le bon dessin est choisi selon la taille affichée — ne jamais agrandir le
 * 16 ou le 32, ni réduire la version détaillée sous 48 px (elle devient illisible).
 */
function pickMark(size: number): string {
  if (size < 24) return mark16;
  if (size < 48) return mark32;
  return markFull;
}

export function LogoMark({ size = 32, label }: {
  /** Côté affiché, en px. Idéalement un multiple de 16, 32 ou 50 pour des pixels nets. */
  size?: number;
  /** Texte alternatif ; absent = décoratif (le nom est déjà écrit à côté). */
  label?: string;
}) {
  return (
    <img
      src={pickMark(size)}
      width={size}
      height={size}
      alt={label ?? ''}
      aria-hidden={label ? undefined : true}
      draggable={false}
      style={{ display: 'block', flexShrink: 0, imageRendering: 'pixelated' }}
    />
  );
}
